import { useQuery } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { QueryConfig } from "@/lib/react-query"

import { AuthPermissionModuleResponse } from "../types/api"

export const getModulePermission =
  (): Promise<AuthPermissionModuleResponse> => {
    return api.get("/auth/permissions/webapp/modules")
  }

type QueryFnType = typeof getModulePermission

type UseModulePermissionResponseOptions = {
  config?: QueryConfig<QueryFnType>
}

export const useModulePermission = ({
  config,
}: {
  config?: UseModulePermissionResponseOptions
}) => {
  return useQuery({
    queryKey: ["modulePermission"],
    queryFn: getModulePermission,
    ...config,
  })
}
